export default __webpack_public_path__ + "static/infopedia-08f75205eb6fb4fa95955540e1c0a92a.svg";